import { FC } from "react";
import { Checkbox, Form, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { BaseFilter } from "src/constants";
import { CATEGORY_ICONS } from "src/Modules/Hotels/Pages/HotelBooking/constants";

const FacilitiesSelect: FC<{
  filter: BaseFilter;
  valuesMap?: Map<any, any[]>;
  isFetching?: boolean;
}> = ({
  filter,
  valuesMap,
  isFetching,
}) => {
  const { t } = useTranslation();

  const categories = Object.keys(CATEGORY_ICONS);

  return (
    <Form.Item name={filter.key} className="m-0!">
      <Checkbox.Group className="flex w-full flex-col items-start gap-1">
        {categories.map((category) => (
          <Checkbox
            key={category}
            value={category}
            className="w-full! whitespace-nowrap"
            classNames={{ root: "w-full!", label: "w-full!" }}
          >
            <div className="flex w-full items-center justify-between">
              <span>{t(`Hotels.booking.facilityCategories.${category}`, { defaultValue: category })}</span>
              {isFetching ? (
                <SkeletonBox className="h-3! w-5!" />
              ) : (
                <span className="text-font-minimal">({valuesMap?.get(category)?.length ?? 0})</span>
              )}
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
    </Form.Item>
  );
};

export default FacilitiesSelect;
